import React from 'react';
import PendingReturnButtons from './PendingReturnButtons'
import OrderArticleSearch from './OrderArticleSearch';

const ReturnsSearch = ({ onSearch, onOrderSelect, showDetails, add, deletePendingRow, returnSchema, setError }) => {

    return (
        <div className="returns" >
            <PendingReturnButtons
                showDetails={showDetails}
                deletePendingRow={deletePendingRow}
                returnSchema={returnSchema}
                setError={setError}
            />
            <OrderArticleSearch
                onSearch={onSearch}
                onOrderSelect={onOrderSelect}
                add={add}
                deletePendingRow={deletePendingRow} />
        </div>
    );
}

export default ReturnsSearch;